module.exports = __webpack_public_path__ + "img/img18.ba781ebe.svg";